import { SongUb } from "../../gql/graphql";

export class SongbookMapExtractor {
  public extractSongbooks(
    playlistEntries: readonly SongUb[],
  ): Map<string, string> {
    const map = new Map<string, string>();
    playlistEntries.forEach((v) =>
      v.songnumbers.forEach((sn) => {
        map.set(sn.songbook.id, sn.songbook.name);
      }),
    );
    return map;
  }
}
